import { z } from "zod";
import { listPreferencesSchema } from "@/components/listPreferences";

export const studySortSchema = z.object({
    key: z.string(),
    order: z.enum(["asc", "desc"]),
});
export const studyViewSchema = z.object({
    tab: z.enum([
        "all",
        "in_study",
        "submitted",
        "not_submitted",
        "awarded",
        "not_awarded",
    ]),
    search: z.string().max(500),
    client: z.string(),
    year: z.string(),
    due: z.boolean(),
    sort: studySortSchema,
    preferences: listPreferencesSchema,
    pageSize: z.number().int().min(1).max(100).default(20),
});
export type StudyViewState = z.infer<typeof studyViewSchema>;

export const isDueSoon = (submissionDate?: string | null): boolean => {
    if (!submissionDate) {
        return false;
    }
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 7);
    const dateKey = (date: Date): string =>
        `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    const value = submissionDate.slice(0, 10);
    return value >= dateKey(now) && value <= dateKey(end);
};
